import { Hero } from '@ingeniorforeningen/figurine-cms';
import React from 'react';
import { LayoutProps } from '../types';

const FrontPageLayout = (props: LayoutProps) => {
  const { children } = props;

  return (
    <>
      <Hero data={props} test="hero" />
      <section>{children}</section>
    </>
  );
};

export default FrontPageLayout;
